export const modalText = {
  premium:
    "Welcome to AskChristee! Complete your profile to make it visible for potential homebuyers",
  basic:
    "Welcome to AskChristee! Before you start, please complete your profile",
};
